import Vue from 'vue';

export default class GeneralService {
    private base_url = 'https://sazgarotp.azurewebsites.net'

    public async sendCode(phone: string) {
        const response = await Vue.axios.post(this.base_url + '/api/send_code', {
          country_code: '92',
          phone_number: phone,
        },
        );
    
        const body = response.data;
    
        if (response.status !== 200) {
          throw Error(body.message);
        }
    
        return body;
      }

      public async verifyCode(code: string) {
        const response = await Vue.axios.post(this.base_url + '/api/verify_code', {
            code: code,
            authy_user_id: localStorage['sazgarbaic_authy_code'],
        },
        );
    
        const body = response.data;
    
        if (response.status !== 200) {
          throw Error(body.message);
        }
    
        return body;
      }
}